import { packagingCode } from '@/utils/packagingCode.js';

export class ProductModel {
  constructor(data) {
    this.productInformation = {
      basicInformation: {
        productArticleNumber: data.articleNumber,
        productBrandName: data.brandName,
        productName: data.productName,
        productStartDate: this.formatDate(data.startDate),
        productTargetMarkets: data.targetMarket.map((a) => a.code),
      },
      extendedInformation: {
        shelfLifeAfterProduction: data.shelfLifeAfterProduction,
        shelfLifeAfterArrival: data.shelfLifeAfterArrival,
        alcoholPercentage: data.percentageOfAlcoholByVolume
      }
    };

    this.productPackagingHierarchy = data.productHierarchy.map((variant) => {
      return variant
        .map((gtin, i) => {
          if (gtin) {
            return {
              tradeItemUnitDescriptorCode: packagingCode[i],
              GTIN: this.addLeadingZero(gtin)
            };
          }
        })
        .filter((gtin) => gtin);
    });
  }

  addLeadingZero(gtin) {
    // all GTINs must be with 14 digits
    if (!gtin) {
      return null;
    }
    return String(gtin).padStart(14, '0');
  }

  formatDate(date) {
    if (!date) return null;

    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day}`;
  }
}
